export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/rings.33aeb5d7.svg","height":125,"width":323};